module.exports = __webpack_public_path__ + "img/hydroponic-gardening.d55a9e76.png";